let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9L70K")).then(() => parcelRequire('8d2Gk'));